import React from 'react';
import { SectionHeading } from './SectionHeading';
const items = [{
  emoji: '📦',
  label: 'Cartone',
  tone: 'bg-coral-light'
}, {
  emoji: '🧴',
  label: 'Bottiglie',
  tone: 'bg-sky-light'
}, {
  emoji: '✂️',
  label: 'Forbici',
  tone: 'bg-sunshine-light'
}, {
  emoji: '🖊️',
  label: 'Penne',
  tone: 'bg-brand-light'
}, {
  emoji: '🔧',
  label: 'Nastro adesivo',
  tone: 'bg-mint-light'
}, {
  emoji: '🪩',
  label: 'Tappi',
  tone: 'bg-coral-light'
}];
export function Materials() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-106" data-mp="1v55lv9wkxx52">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-107" data-mp="1v6qh71qpxk3z">
        <SectionHeading eyebrow="🛒 Cosa ti serve" title={<>Solo oggetti di tutti i giorni che hai in casa</>} subtitle="Nessun kit di robotica. Nessun componente costoso. Solo cose che hai già." data-id="element-108" data-mp="1qep81oouk9i6" />
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-6" data-id="element-109" data-mp="xoyubgr4n9ml">
          {items.map(it => <div key={it.label} className={`flex flex-col items-center gap-3 rounded-2xl border border-ink/10 px-4 py-8 text-center ${it.tone}`} data-id="element-110" data-mp="10u2ar6vuisrj">
              <span className="text-4xl" aria-hidden="true" data-id="element-111" data-mp="1aknibjthz7ml">
                {it.emoji}
              </span>
              <span className="text-sm font-semibold text-ink" data-id="element-112" data-mp="1ekxlkopwnjxr">{it.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}